import { useState, useEffect } from 'react';
import { useSubQr } from './useSubQr';
import LoadingSpinner from '../../components/LoadingSpinner';
import styles from  './SubQrInit.module.css';

const SubQrInit = () => {
    const { data, isLoading, initializeSubQr } = useSubQr();

    useEffect(() => {
        if (data?.subQr?.dateInitialized && data?.parent?.redirect_url) {
            window.location.assign(data?.parent?.redirect_url);
        };
    },[data?.parent?.redirect_url, data?.subQr?.dateInitialized]);

    const [ response, setResponse ] = useState('');
    const [ success, setSuccess ] = useState(false);

    const handleState = e => setResponse(e.target.value);
    
    return (
        <div className={styles.wrapper}>
            <div className={styles.container} >
                <div className={styles.display}>
                    <div className={styles.body} >
                        {isLoading ?
                            <LoadingSpinner />
                        :
                        success ?
                            <div>Scan again to ensure initialization</div>
                        :
                            <>
                            <div className={styles.questions}>
                                <div className={styles.inputGroup}>
                                    <label htmlFor='for-location' className={styles.label} >Where is this flyer being put up?</label>
                                    <input id='for-location' type='text' name={'location'} className={styles.input} value={response} onChange={handleState} ></input>
                                </div>
                            </div>
                            <div className={styles.btnContainer}>
                                <button className={styles.btn} disabled={!response} onClick={() => initializeSubQr(response, setSuccess)} >Add Location</button>
                                <button className={styles.btn} onClick={() => setResponse('')} >Cancel</button>
                            </div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubQrInit;
